export const rigidBodies = [];
export const svgObjects = [];
// ✅ OPTYMALIZACJA: Skip sleeping objects
export function updateRigidBodies() {
    for (const obj of rigidBodies) {
        const b = obj.userData.physicsBody;
        if (!b) continue;
        
        // Pomiń obiekty, które śpią (nie poruszają się)
        if (b.isSleeping && b.isSleeping()) continue;
        
        const p = b.translation();
        const r = b.rotation();
        obj.position.set(p.x, p.y, p.z);
        obj.quaternion.set(r.x, r.y, r.z, r.w);
    }
}
